import template from "./report-actions.html";
import "./report-actions.less";
import {
	ACTION_EXPAND_DETAILS,
	ACTION_COLLAPSE_DETAILS,
	ACTION_EXPAND_INVOICES,
	ACTION_COLLAPSE_INVOICES
} from "constants.js";

function controller(
	$logger,
	appState,
	$uibModal,
	$timeout
) {
	const ctrl = this;

	ctrl.handlePrint = handlePrint;
	ctrl.canBeDeleted = canBeDeleted;
	ctrl.canBeWithdrawn = canBeWithdrawn;
	ctrl.canBeRestored = canBeRestored;

	ctrl.$onInit = () => {
		ctrl.eventBus = ctrl.reportScope.events;
		ctrl.form = appState.forms.selected;
		ctrl.permissions = appState.permissions;
		checkAccesses();
	};

	ctrl.$onChanges = () => {
		ctrl.permissions = appState.permissions;
		checkAccesses();
	};

	ctrl.withdraw = () => {
		$logger.event($logger.buildReportEvent("withdraw")("requested"), {
			via: "report-actions"
		});
		ctrl.handleWithdraw();
	};

	ctrl.delete = () => {
		$logger.event($logger.buildReportEvent("delete")("requested"), {
			via: "report-actions"
		});
		ctrl.handleDelete();
	};

	ctrl.restore = () => {
		$logger.event($logger.buildReportEvent("restore")("requested"), {
			via: "report-actions"
		});
		ctrl.handleRestore();
	};

	function checkAccesses() {
		ctrl.currentHistory = ctrl.orderedHistory[0];
		ctrl.canWithdraw = false;
		ctrl.canDelete = false;
		ctrl.canRestore = false;
		ctrl.showExportIcon = ctrl.report.Exports !== undefined
			&& ctrl.report.Exports.length > 0
			&& ctrl.permissions.Reporting.Actions.CanViewExports;

		if(!ctrl.permissions.Reporting.IsDisabled) {
			canBeWithdrawn();
			canBeDeleted();
			canBeRestored();
		}
	}

	function handlePrint() {
		ctrl.eventBus.trigger(ACTION_EXPAND_DETAILS);
		ctrl.eventBus.trigger(ACTION_EXPAND_INVOICES);

		let didCollapse = false;
		let fallbackTimer = null;

		const collapseAfterPrint = () => {
			if(didCollapse) {
				return;
			}

			didCollapse = true;
			if(fallbackTimer !== null) {
				clearTimeout(fallbackTimer);
			}

			ctrl.eventBus.trigger(ACTION_COLLAPSE_DETAILS);
			ctrl.eventBus.trigger(ACTION_COLLAPSE_INVOICES);
		};

		const printMedia = window.matchMedia ? window.matchMedia("print") : null;

		if(printMedia && printMedia.addEventListener) {
			const mediaListener = (event) => {
				if(event.matches === false) {
					collapseAfterPrint();
					printMedia.removeEventListener("change", mediaListener);
				}
			};

			printMedia.addEventListener("change", mediaListener);
		}

		window.addEventListener("afterprint", collapseAfterPrint, { once: true });

		$timeout(() => {
			window.print();
			$logger.event($logger.buildReportEvent("print")("executed"));

			fallbackTimer = setTimeout(() => {
				collapseAfterPrint();
			}, 3000);
		});
	}

	function canBeWithdrawn() {
		ctrl.canWithdraw = (
			ctrl.permissions.Reporting.Actions.CanWithdraw
				&& ctrl.currentHistory.State.Code === "SUBMITTED"
				&& ctrl.currentHistory.State.Code !== "DELETED"
		) || (
			ctrl.currentHistory.State.Code === "SUBMITTING"
				&& (appState.operatingUserRole === "AGENT" || appState.operatingUserRole === "SYSADMIN")
		);

		return ctrl.canWithdraw;
	}

	function canBeDeleted() {
		ctrl.canDelete = ctrl.permissions.Reporting.Actions.CanDelete
			&& ctrl.currentHistory.State.Code !== "SUBMITTED"
			&& ctrl.currentHistory.State.Code !== "DELETED";

		return ctrl.canDelete;
	}

	function canBeRestored() {
		ctrl.canRestore = ctrl.permissions.Reporting.Actions.CanRestore
			&& ctrl.currentHistory.State.Code !== "SUBMITTED"
			&& ctrl.currentHistory.State.Code === "DELETED";

		return ctrl.canRestore;
	}

	ctrl.handleViewExport = () => {
		$uibModal.open({
			component: "export-information",
			size: "xlg",
			resolve: {
				exports: () => ctrl.report?.Exports,
				report: () => ctrl.report
			},
			getUsers: () => undefined
		}).result.then(() => {

		});
	};
}

export default angular
	.module("vesl.components.report-actions", [])
	.component("reportActions", {
		template,
		transclude: true,
		controller,
		bindings: {
			report: "<",
			handleDelete: "<",
			handleWithdraw: "<",
			handleRestore: "<",
			orderedHistory: "<"
		},
		require: {
			reportScope: "^^reportScope"
		}
	}).name;
